class EventEmitter {
  static emit(type, element) {
    let event
    if (typeof element === "undefined") {
      element = document
    }

    if (element.createEvent) {
      event = new window.Event(type)
      element.dispatchEvent(event)
    } else {
      event = element.createEventObject()
      element.fireEvent("on" + type, event)
    }
  }

  static listen(type, callback, element) {
    if (typeof element === "undefined") {
      element = document
    }

    element.addEventListener(type, callback, false)

    return this
  }

  static once(type, callback, element) {
    if (typeof element === "undefined") {
      element = document
    }

    element.addEventListener(type, callback, { once: true })

    return this
  }

  static remove(type, callback, element) {
    if (typeof element === "undefined") {
      element = document
    }

    element.removeEventListener(type, callback)
  }
}

export default EventEmitter
